import {useEffect} from 'react';
import OneSignal from 'react-onesignal';



const useOneSignalInitialization = () => {

    useEffect(() => {
        const initializeOneSignal = async () => {
            try {
                const oneSignalAppId = window.oneSignalAppId;
                if (oneSignalAppId) {
                    await OneSignal.init({
                        appId: oneSignalAppId,
                        allowLocalhostAsSecureOrigin: true,
                        notifyButton: {
                            enable: true,
                        },
                    });
                } else {
                    console.error("OneSignal App ID is undefined");
                }
            } catch (error) {
                console.error("Error initializing OneSignal", error);
            }
        };

        initializeOneSignal();
    }, []);

    return {

    };
};

export default useOneSignalInitialization;
